export default "__VITE_ASSET__Cp8bgTJf__"